import { notFound } from '@tanstack/react-router';

import { featureFlags } from '@/lib/env';

/**
 * DEAL_LEDGER feature flag が無効な環境では deal 配下のルートへのアクセスを 404 にする。
 *
 * サイドメニューの非表示（sidebarConfig）と合わせ、URL 直叩きでの到達も防ぐ。
 * 値の出し分け（prd は非表示 / stg・demo・dev・local は表示）は backend の
 * feature-flag-definitions.ts が単一の正であり、FE は /v2/session が返す値を参照するだけ。
 */
export function assertDealLedgerEnabled(): void {
  if (!featureFlags.check('DEAL_LEDGER')) {
    throw notFound();
  }
}
